<template>
    <div class="mt-1 app-left-margin app-right-margin w-100" v-resize="onResize">
        <d-site
            v-if      = "unit.selected"
            v-model   = "unit.show"
            :site-id  = "unit.selected.id"
        />

        <company-app-bar
            title       = "DOKUMENTE"
            :categories = "[]"
            @search     = "() => {}"
        />

        <div class="document-container" >
            <v-row class="no-frame">
                <v-col class="no-border col-3">
                    <p-dms-treeview-card-header
                        class="mt-n1"
                        @customer = "onCustomers"
                        @expand   = "onExpandFilter"
                    />

                    <p-dms-treeview-card-body
                        class     = "lm-border pt-1"
                        style     = " width: calc(100% - 8px); margin-top: 5px"
                        :style    = "bodyStyle"
                        :customer = "customer"
                        :height   = "height"
                        @unit     = "onSite"
                        @selected = "onSelected"
                    />
                </v-col>
                <v-col class="mt-n2 no-border col-9">
                    <c-dms-treeview-unit
                        class      = "pr-1 mr-2"
                        v-if       = "unit.selected"
                        :unit      = "unit.selected"
                        :height    = "height-2"
                        :col-width = "['col-1', 'col-2']"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import Core                   from "@/modules/core/service/Core";
import CompanyAppBar          from "@/modules/msd/company/common/components/nav/CompanyAppBar.vue";
import CDmsTreeviewUnit       from "@/modules/dms/treeview/components/CDmsTreeviewUnit.vue";
import DSite                  from "@/modules/msd/unit/components/dialog/DSite.vue";
import PDmsTreeviewCardHeader from "@/modules/dms/treeview/components/private/PDmsTreeviewCardHeader.vue";
import PDmsTreeviewCardBody   from "@/modules/dms/treeview/components/private/PDmsTreeviewCardBody.vue";

export default {
    name: "MDmsTreeview",

    components: {
        PDmsTreeviewCardBody,
        PDmsTreeviewCardHeader,
        DSite,
        CDmsTreeviewUnit,
        CompanyAppBar
    },

    data: () => ({
        customer: null,
        expand  : null,
        show: false,
        search: null,
        height: null,
        unit: {
            selected: null,
            show    : null
        }
    }),

    computed: {
        bodyStyle () {
            return 'max-height:' + this.height + 'px; height:' + this.height + 'px'
        }
    },

    mounted() {
        this.onResize();
    },

    methods: {
        onHome () {
            Core.nav.home(this);
        },

        onResize () {
            this.height = window.innerHeight-110;
            if (this.expand === 0) {
                this.height -= 170;
            }
        },

        onExpandFilter (expand) {
            this.expand = expand;
            this.onResize();
        },

        onCustomers (customer) {
            this.customer = customer;
        },

        onSite (unit) {
            this.unit.selected = unit;
            this.unit.show = true;
        },

        onSelected (unit) {
            this.unit.selected = unit;
        },
    }
}
</script>

<style scoped>

.document-container {
    width: calc(100% - 75px);
    border-top-style: solid;
    border-top-width: 1px;
    border-top-color: lightgray;
    padding-top: 12px;
    margin-top: 4px;
}


::v-deep .v-expansion-panel-content__wrap {
    margin: 0;
    padding: 0;
}

::v-deep .v-expansion-panel-header {
    min-height: 30px!important;
}

::v-deep .col-1 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}

::v-deep .col-2 {
    flex: 0 0 66.6666666666%;
    max-width: 66.666666666%;
}

</style>